export default {
    events: {
        create: '/create'
    }
}
